module.exports = __webpack_public_path__ + "static/brave-new-world-56364509f42b088f45280191b867872a.jpg";